﻿﻿import axios from 'axios';
import {APIUrl} from '../constants/ApplicationConstants.js';
import ProductsApiCallBackActions from '../actions/ProductsApiCallBackActions.js';
import {getError as Error, ThrowIfStatusNotOk} from './ApiHelper.js';
import Mapper from '../utils/Mapper';
import {MappingConfigurations} from '../constants/YourDetailsConstants.js';

﻿﻿module.exports = {
﻿﻿    getProductList: function() {
﻿﻿        const companyCode = window.NOA.userContext.companyCode;
﻿﻿        const url = APIUrl.PRODUCT_LIST + '?companyCode=' + companyCode;

﻿﻿        axios.get(url)
﻿﻿            .then(ThrowIfStatusNotOk)
﻿﻿            .then((response) => {
﻿﻿                var data = Mapper.arrayOfObjectMapper(response.data, MappingConfigurations.Products);
﻿﻿                ProductsApiCallBackActions.receiveProductList(data);
﻿﻿            })
﻿﻿            .catch((error) => {
﻿﻿                throw Error('Product List', error);
﻿﻿            });
﻿﻿    },

﻿﻿    getAnnuityQuoteUrl: function(productId, applicationNumber) {
﻿﻿        const url = APIUrl.BASE_PRODUCTS_URL + productId + APIUrl.ANNUITY_QUOTE_URL + applicationNumber;

﻿﻿        axios.get(url)
﻿﻿            .then(ThrowIfStatusNotOk)
﻿﻿            .then((response) => {
﻿﻿                ProductsApiCallBackActions.receiveAnnuityQuoteUrl(response.data);
﻿﻿            })
﻿﻿            .catch((error) => {
﻿﻿                throw Error('Annuity Quote URL', error);
﻿﻿            });
﻿﻿    },

﻿﻿    getIsProductRegistered: function(productId) {
﻿﻿        const url = APIUrl.GET_IS_PRODUCT_REGISTERED.replace('{aid}', window.NOA.userContext.oin)
﻿﻿            .replace('{pid}', productId);

﻿﻿        axios.get(url)
﻿﻿            .then(ThrowIfStatusNotOk)
﻿﻿            .then((response) => {
﻿﻿                ProductsApiCallBackActions.receivedIsProductRegistered(response.data);
﻿﻿            })
﻿﻿            .catch((error) => {
﻿﻿                throw Error('Is Product Registered', error);
﻿﻿            });
﻿﻿    }
﻿﻿};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./apis/ProductsAPI.js